import * as angular from 'angular';
import _ = require('underscore');

class CampaignKeywords {
    message: string;
    $onChanges(changes: any) {
        if (changes.keywords && changes.keywords.currentValue) {
            var keywords = _.pluck(changes.keywords.currentValue, 'keyword');
            this.message = keywords.join('; ');
        } else {
            this.message = null;
        }
    }
}

angular
    .module('app.retailes.common')
    .component('campaignKeywords', {
        template: require('./campaign-keywords.html'),
        controller: CampaignKeywords,
        controllerAs: 'vm',
        bindings: {
            keywords: '<',
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/campaign-keywords/campaign-keywords.component.ts